import { imageUrl } from 'utils/utils';

interface ImagePopupProps {
  popupData: PopupInfoDetailResDto;
  onCloseWithReadPopup: () => void;
  onClose: () => void;
}

const ImagePopup = ({ onCloseWithReadPopup, popupData, onClose }: ImagePopupProps) => {
  if (!popupData.imageUri) return null;

  const { linkUri } = popupData;
  const isAbsoluteLink = !!linkUri && /^(https?:)?\/\//i.test(linkUri);
  const popupImage = <img src={imageUrl(popupData.imageUri)} alt={popupData.title} />;

  return (
    <div className="popup image_popup is-active">
      <div className="popup_dim"></div>
      <div className="popup_inner">
        <div className="image_wrapper">
          {linkUri ? (
            <a
              href={linkUri}
              target={isAbsoluteLink ? '_blank' : '_self'}
              rel={isAbsoluteLink ? 'noopener noreferrer' : undefined}
            >
              {popupImage}
            </a>
          ) : (
            popupImage
          )}
        </div>
        <div className="popup_footer">
          <button type="button" onClick={() => onCloseWithReadPopup()}>
            하루동안 보지 않기
          </button>
          <button type="button" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImagePopup;
